// extracted by mini-css-extract-plugin
export default {"no-padding":"no-padding-ff87","subtitle":"subtitle-f9d2","image":"image-a941"};